import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrganizationCatalogService } from "src/app/services/organization-catalog/organization-catalog.service";
import { loadOrganizationCatalog, loadOrganizationCatalogByID, loadOrganizationCatalogByTenantID, loadOrganizationCatalogFailed, loadOrganizationCatalogSuccess, loadOrganizationCatalogTemplates, loadOrganizationCatalogTemplatesFailed, loadOrganizationCatalogTemplatesSuccess } from "../actions/organization-catalog.actions";

@Injectable()
export class OrganizationCatalogEffects {
	private actions$ = inject(Actions);
	private organizationCatalogService = inject(OrganizationCatalogService);


	// Load the organization product catalog from backend blob storage
	loadOrganizationCatalog$ = createEffect(() => this.actions$.pipe(
		ofType(loadOrganizationCatalog),
		switchMap((action) =>
			this.organizationCatalogService.loadCatalogInfo(action.subscriptionId).pipe(
				map(resp => loadOrganizationCatalogSuccess({ organizationCatalog: resp.data })),
				catchError(async (error) => loadOrganizationCatalogFailed({ error: error }))
			)
		)
	));

	// Load the organization product catalog from backend blob storage
	loadOrganizationCatalogById$ = createEffect(() => this.actions$.pipe(
		ofType(loadOrganizationCatalogByID),
		switchMap((action) =>
			this.organizationCatalogService.getCatalog(action.catalogId).pipe(
				map(resp => loadOrganizationCatalogSuccess({ organizationCatalog: resp.data })),
				catchError(async (error) => loadOrganizationCatalogFailed({ error: error }))
			)
		)
	));

	// Load the organization product catalog from backend blob storage
	loadOrganizationCatalogByTenantID$ = createEffect(() => this.actions$.pipe(
		ofType(loadOrganizationCatalogByTenantID),
		switchMap((action) =>
			this.organizationCatalogService.getTenantCatalog(action.tenantId, "organization").pipe(
				map(resp => loadOrganizationCatalogSuccess({ organizationCatalog: resp.data })),
				catchError(async (error) => loadOrganizationCatalogFailed({ error: error }))
			)
		)
	));

	// Load the organization product catalog from backend blob storage
	loadOrganizationCatalogProduct$ = createEffect(() => this.actions$.pipe(
		ofType(loadOrganizationCatalogTemplates),
		switchMap((action) =>
			this.organizationCatalogService.loadCatalogTemplates(action.catalogId).pipe(
				map(resp => loadOrganizationCatalogTemplatesSuccess({ templates: resp.data })),
				catchError(async (error) => loadOrganizationCatalogTemplatesFailed({ error: error }))
			)
		)
	));
}
